import dynamic from "next/dynamic";
const SideBySideParagraphAndProductsTabsComponent = dynamic(()=>import("./side-by-side-paragraph-and-products-tabs-component"));
import SideBySideParagraphAndProductsTabsConfig from "./side-by-side-paragraph-and-products-tabs-config";
import SideBySideParagraphAndProductsTabsAdvancedConfig from "./side-by-side-paragraph-and-products-tabs-advanced-config";
export default {
    SideBySideParagraphAndProductsTabsComponent,
    SideBySideParagraphAndProductsTabsConfig,
    SideBySideParagraphAndProductsTabsAdvancedConfig
};
